var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}}),_c('IconComponent',{attrs:{"name":"play"}})],1):_c('LoadingIndicator',{attrs:{"title":"Загрузка..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }